import ReactDOM from "react-dom";
import "./Theme/index.css";
import App from "./App";
import "./widget-loader";

import theme from "./Theme/Theme";
import reportWebVitals from "./reportWebVitals";
import { Provider } from "react-redux";
import Store from "./store";
import { ConfigProvider } from "antd";

import React from "react";
import { createRoot } from "react-dom/client";
// import { render } from "react-snapshot";
const container = document.getElementById("root");

if (container) {
  const root = createRoot(container);

  root.render(
    <Provider store={Store}>
      <App />
    </Provider>
  );
}
// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
